export enum LottieAnimations {
  BackgroundLines,
  Spinner,
  OutroSpinner,
}
